import { lazy } from 'react';
import Loadable from '../components/layouts/loader/Loadable';
import ProtectRoute from '../components/protectRoutes/ProtectRoute';
import { adminRole, superAdminRole, userRole } from '../components/common/constant';
import _ from 'lodash';

/****Layouts*****/
const BlankLayout = Loadable(lazy(() => import('../components/layouts/BlankLayout')));
const FullLayout = Loadable(lazy(() => import('../components/layouts/FullLayout')));
/***** Web Pages ****/
const Home = Loadable(lazy(() => import('../views/website/home')));
const AboutUs = Loadable(lazy(() => import('../views/website/aboutUs')));
const ContactUs = Loadable(lazy(() => import('../views/website/contactUs')));
const Product = Loadable(lazy(() => import('../views/website/product')));
// const HowToStart = Loadable(lazy(() => import('../views/website/howToStart')));
/***** Auth Pages ****/
const AuthLogin = Loadable(lazy(() => import('../views/auth/login')));
const AuthForgetPassword = Loadable(lazy(() => import('../views/auth/forgetPassword')));
const AuthRegister = Loadable(lazy(() => import('../views/auth/register')));

/***** Super Admin Pages ****/
// Dashboard
const SuperAdminDashboard = Loadable(lazy(() => import('../views/superAdmin/dashboard')));
// Setting
const PackageList = Loadable(lazy(() => import('../views/superAdmin/settings/package')));
const LevelIncomeList = Loadable(lazy(() => import('../views/superAdmin/settings/levelIncome')));
const AppConfig = Loadable(lazy(() => import('../views/superAdmin/settings/appConfig')));
// Account Setting
const SuperAdminChangePassword = Loadable(lazy(() => import('../views/superAdmin/profile/changePassword')));
const SuperAdminMyProfile = Loadable(lazy(() => import('../views/superAdmin/profile/myProfile')));

/***** Admin Pages ****/
// Dashboard
const AdminDashboard = Loadable(lazy(() => import('../views/admin/dashboard')));
// User Manegement
const MemberUserList = Loadable(lazy(() => import('../views/admin/userManagement/memberList')));
const MemberLotteryList = Loadable(lazy(() => import('../views/admin/userManagement/memberLotteryList')));
// Geneology
const Binary = Loadable(lazy(() => import('../views/admin/geneology/binary')));
const CompanyAutoPull = Loadable(lazy(() => import('../views/admin/geneology/companyAutoPull')));
const TeamAutoPull = Loadable(lazy(() => import('../views/admin/geneology/teamAutoPull')));
const MySponserList = Loadable(lazy(() => import('../views/admin/geneology/mySponser')));
const MyTeamList = Loadable(lazy(() => import('../views/admin/geneology/myTeams')));
// Wallet
const IncomeWalletData = Loadable(lazy(() => import('../views/admin/wallet/incomeWallet')));
const CryptoWalletList = Loadable(lazy(() => import('../views/admin/wallet/cryptoWallet')));
const WithdrawalHistoryAdmin = Loadable(lazy(() => import('../views/admin/wallet/withdrawalHistory')));
// Income
const GenerateIncome = Loadable(lazy(() => import('../views/admin/income/generateIncome')));
const IncomeHistory = Loadable(lazy(() => import('../views/admin/income/incomeHistory')));
const PayoutIncomeHistory = Loadable(lazy(() => import('../views/admin/income/payoutIncomeHistory')));
// Bank Setting
const AdminMyBank = Loadable(lazy(() => import('../views/admin/bank/myBank')));
const UserBankList = Loadable(lazy(() => import('../views/admin/bank/userBankList')));
// Account Setting
const MyProfile = Loadable(lazy(() => import('../views/admin/profile/myProfile')));
const ChangePassword = Loadable(lazy(() => import('../views/admin/profile/changePassword')));
// Pin System
const PinDetailList = Loadable(lazy(() => import('../views/admin/pinSystem/pinDetailList')));

/***** User Pages ****/
// Dashboard
const UserDashboard = Loadable(lazy(() => import('../views/user/dashboard')));
// Geneology
const UserBinary = Loadable(lazy(() => import('../views/user/geneology/binary')));
const CompanyAutoPullUser = Loadable(lazy(() => import('../views/user/geneology/companyAutoPull')));
const TeamAutoPullUser = Loadable(lazy(() => import('../views/user/geneology/teamAutoPull')));
const UserMySponserList = Loadable(lazy(() => import('../views/user/geneology/mySponser')));
const UserMyTeamList = Loadable(lazy(() => import('../views/user/geneology/myTeams')));
// Wallet
const UserIncomeWalletData = Loadable(lazy(() => import('../views/user/wallet/incomeWallet')));
const UserCryptoWalletList = Loadable(lazy(() => import('../views/user/wallet/cryptoWallet')));
const WithdrawalHistory = Loadable(lazy(() => import('../views/user/wallet/widthdrawalHistory')));
const IncomeHistoryUser = Loadable(lazy(() => import('../views/user/wallet/incomeHistoryUser')));
const PayoutIncomeHistoryUser = Loadable(lazy(() => import('../views/user/wallet/payoutIncomeHistoryUser')));
// Account Setting
const UserMyBank = Loadable(lazy(() => import('../views/user/profile/myBank')));
const UserMyProfile = Loadable(lazy(() => import('../views/user/profile/myProfile')));
const UserChangePassword = Loadable(lazy(() => import('../views/user/profile/changePassword')));
// Pin System
const UserPinDetailList = Loadable(lazy(() => import('../views/user/pinSystem/pinDetailList')));

/*****ADMIN END******/
const ThemeRoutes = [
  // Website
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '*', element: <AuthLogin /> },
      { path: '/login', element: <AuthLogin /> },
      { path: '/register', element: <AuthRegister /> },
      { path: '/', element: <Home /> },
      { path: '/about-us', element: <AboutUs /> },
      { path: '/product', element: <Product /> },
      { path: '/contact-us', element: <ContactUs /> },
      { path: '/forget-password', element: <AuthForgetPassword /> },
    ],
  },
  // Super Admin
  {
    path: '/superAdmin/',
    element: <ProtectRoute component={<FullLayout />} forRole={[_.toNumber(superAdminRole)]} />,
    children: [
      { path: 'dashboard', element: <SuperAdminDashboard /> },
      // Settings
      { path: 'setting/package', element: <PackageList /> },
      { path: 'setting/levelDetails', element: <LevelIncomeList /> },
      { path: 'setting/appConfig', element: <AppConfig /> },
      // Account Setting
      { path: 'myAccount/changePassword', element: <SuperAdminChangePassword /> },
      { path: 'myAccount/profile', element: <SuperAdminMyProfile /> },
      
      // { path: '*', element: <AdminDashboard /> },
    ],
  },
  // Admin
  {
    path: '/admin/',
    element: <ProtectRoute component={<FullLayout />} forRole={[_.toNumber(adminRole)]} />,
    children: [
      { path: 'dashboard', element: <AdminDashboard /> },
      // User Manegement
      { path: 'useManagement/memberUser', element: <MemberUserList /> },
      { path: 'useManagement/lotteryList', element: <MemberLotteryList /> },
      // Geneology
      { path: 'geneology/teamLeaderAutoPull', element: <Binary /> },
      { path: 'geneology/companyAutoPull', element: <CompanyAutoPull /> },
      { path: 'geneology/teamAutoPull', element: <TeamAutoPull /> },
      { path: 'geneology/mySponsor', element: <MySponserList /> },
      { path: 'geneology/selfLevelTeam', element: <MyTeamList /> },
      // Wallet
      { path: 'wallet/incomeWallet', element: <IncomeWalletData /> },
      { path: 'wallet/cryptoWallet', element: <CryptoWalletList /> },
      { path: 'wallet/withdrawalHistory', element: <WithdrawalHistoryAdmin /> },
      // Income
      { path: 'income/generateIncome', element: <GenerateIncome /> },
      { path: 'income/incomeHistory', element: <IncomeHistory /> },
      { path: 'income/payoutIncomeHistory', element: <PayoutIncomeHistory /> },
      // PinSystem
      { path: 'pinSystem/pinDetailList', element: <PinDetailList /> },
      // Bank Setting
      { path: 'bank/myBank', element: <AdminMyBank /> },
      { path: 'bank/usersBank', element: <UserBankList /> },
      // Account Setting
      { path: 'myAccount/profile', element: <MyProfile /> },
      { path: 'myAccount/changePassword', element: <ChangePassword /> },
      
      // { path: '*', element: <AdminDashboard /> },
    ],
  },
  // User
  {
    path: '/user/',
    element: <ProtectRoute component={<FullLayout />} forRole={[_.toNumber(userRole)]} />,
    children: [
      { path: 'dashboard', element: <UserDashboard /> },
      // Geneology
      { path: 'geneology/teamLeaderAutoPull', element: <UserBinary /> },
      { path: 'geneology/companyAutoPull', element: <CompanyAutoPullUser /> },
      { path: 'geneology/teamAutoPull', element: <TeamAutoPullUser /> },
      { path: 'geneology/mySponsor', element: <UserMySponserList /> },
      { path: 'geneology/selfLevelTeam', element: <UserMyTeamList /> },
      // Wallet
      { path: 'wallet/incomeWallet', element: <UserIncomeWalletData /> },
      { path: 'wallet/cryptoWallet', element: <UserCryptoWalletList /> },
      { path: 'wallet/withdrawalHistory', element: <WithdrawalHistory /> },
      { path: 'wallet/incomeHistory', element: <IncomeHistoryUser /> },
      { path: 'wallet/payoutIncomeHistory', element: <PayoutIncomeHistoryUser /> },
      // PinSystem
      { path: 'pinSystem/pinDetailList', element: <UserPinDetailList /> },
      // Account Setting
      { path: 'myAccount/myBank', element: <UserMyBank /> },
      { path: 'myAccount/profile', element: <UserMyProfile /> },
      { path: 'myAccount/changePassword', element: <UserChangePassword /> },
    ],
  },
];

export default ThemeRoutes;
